import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GruppoTipiDanno } from '../models/gruppo-tipi-danno';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class GruppoTipiDannoService extends ResourcefulService<GruppoTipiDanno>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, GruppoTipiDanno);
    }
}
